import { render } from "./luckyWheelResult.vue?vue&type=template&id=ebb77620"
import script from "./luckyWheelResult.vue?vue&type=script&lang=js"
export * from "./luckyWheelResult.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__